<template>
    <div class="c-modal-save-cc">
        <b-modal :title="Core.Definition.getDefinition('Enregistrer une nouvelle carte')" v-model="dataShow" :hide-footer="true" cancel-variant="light">
            <InputCC
                    ref="CC"
                    :onTokenizationSuccess="onTokenizationSuccess"
                    v-model="dataCC"></InputCC>
            <hr/>
            <b-row>
                <b-col class="text-right">
                    <b-button @click="onResetClick" class="btn btn-light mr-3">{{Core.Definition.getDefinition('Réinitialiser')}}</b-button>
                    <b-button @click="onConfirmClick" class="btn btn-success">{{Core.Definition.getDefinition('Enregistrer')}}</b-button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
    import InputCC from './InputCC'
    export default {
        name: 'ModalSaveCC',
        components: {
            InputCC,
        },
        props: {},
        watch: {
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                   return this.dataShow
                }
            }
        },
        mounted() {
        },
        data: () => {
            return {
                Core: window.Core,
                dataShow: false,
                dataCC: {
                    holderName: '',
                    number: '',
                    expMonth: '',
                    expYear: '',
                    CVD: '',
                    token: ''
                }
            }
        },
        methods: {
            onResetClick() {
                this.$refs.CC.reset()
            },
            onConfirmClick() {
                this.$refs.CC.getToken()
            },
            onTokenizationSuccess(token, form) {
                let CC = {
                    token: token,
                    CC: {
                        last4: this.dataCC.number.slice(-4),
                        expMonth: this.dataCC.expMonth,
                        expYear: this.dataCC.expYear,
                    }
                }
                this.$emit('onTokenizationSuccess', CC)
            },
        }
    }
</script>
